/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/12 added to support impacted research views
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedResearchViewConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted research views from response
     * @param serverResponse
     * @returns A array of impacted research views
     */
    static parse(serverResponse): Array<ImpactedResearchViewConfig> {
        const serverRes = serverResponse['screen-list'];
        if (!serverRes) {
            return null;
        }
        const impactedResearchViewConfig: Array<ImpactedResearchViewConfig> = new Array<ImpactedResearchViewConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedResearchViewConfig.push(
                    {
                        name: item.name,
                        type: businessConstants.impactedConfigType.researchView,
                        setting: item.field
                    }
                );
            });
        }
        return impactedResearchViewConfig;
    }
}
